import React from 'react';
import {Carousel} from '@trendyol-js/react-carousel';

import RecommendationCard from './RecommendationCard';
import {Row} from './styled';

import photo1 from 'assets/img/photo1.jpg';
import photo2 from 'assets/img/photo2.jpg';
import photo3 from 'assets/img/photo3.jpg';
import photo4 from 'assets/img/photo3.jpg';

type ModalTypes = {
  reservationId?: string;
};

const windowWidth = () => (window.innerWidth < 400 ? 1 : 3);

function Recommendations({reservationId}: ModalTypes) {
  // const {t} = useTranslation();
  // const handleDownloadButton = React.useCallback(async () => {
  //   console.log('reservationId', reservationId);
  //   if (!reservationId) {
  //     return;
  //   }

  //   const {data, error} = await api.documents.getContracts(
  //     `housing_sample_id=${housingId}`,
  //   );
  //   const contract = get(data, '0.file');

  //   if (contract) {
  //     window.open(contract, '__blank');
  //   }

  //   if (error) {
  //     console.log('error', error);
  //   }
  // }, [housingId, reservationId]);

  return (
    <Row>
      <Carousel
        show={windowWidth()}
        slide={1}
        transition={0.5}
        swiping={true}
        swipeOn={0.25}
        infinite={true}
        responsive={true}
        useArrowKeys={true}
      >
        <RecommendationCard
          id={1}
          photo={photo1}
          name="Private landscape photography tour"
          desc="The best 16 passenger small group, intimate and unique, Milford Sound..."
          hours={12}
          people={10}
          price={267}
        />
        <RecommendationCard
          id={2}
          photo={photo2}
          name="Private landscape photography tour"
          desc="The best 16 passenger small group, intimate and unique, Milford Sound..."
          hours={12}
          people={10}
          price={267}
        />
        <RecommendationCard
          id={3}
          photo={photo3}
          name="Private landscape photography tour"
          desc="The best 16 passenger small group, intimate and unique, Milford Sound..."
          hours={12}
          people={10}
          price={267}
        />
        <RecommendationCard
          id={4}
          photo={photo4}
          name="Private landscape photography tour"
          desc="The best 16 passenger small group, intimate and unique, Milford Sound..."
          hours={12}
          people={10}
          price={267}
        />
      </Carousel>
    </Row>
  );
}

export default Recommendations;
